import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { canAccessRoute } from "../config/routeAccess";

export default function ProtectedRoute({ children, path }) {
  const { currentUser, loadingUser } = useAuth();

  if (loadingUser) return null;
  if (!currentUser) return <Navigate to="/login" replace />;
  if (!canAccessRoute(currentUser, path)) return <Navigate to="/no-access" replace />;

  return children;
}
